import { render, staticRenderFns } from "./AddRegionPage.vue?vue&type=template&id=18426390&"
import script from "./AddRegionPage.vue?vue&type=script&lang=js&"
export * from "./AddRegionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports